var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeoplesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5966 15.8334C11.2845 16.5573 11.1113 17.3553 11.1113 18.195C11.1113 18.4686 11.1297 18.7378 11.1643 19H22.9467C22.9816 18.7378 23 18.4686 23 18.195C23 17.3553 22.8266 16.5573 22.5145 15.8334C22.1863 15.0679 21.7008 14.3837 21.0998 13.8269V13.8247C20.041 12.8364 18.6194 12.2308 17.0567 12.2308C15.39 12.2308 13.8829 12.9199 12.8033 14.0288M11.5966 15.8334C11.8857 15.1586 12.2971 14.5461 12.8033 14.0288M11.5966 15.8334L1.0555 15.8334C1.01843 15.569 1 15.3023 1 15.0285C1 11.7344 3.66307 9.06426 6.94558 9.06426C9.88839 9.06426 12.3317 11.2104 12.8033 14.0288M21.0003 8.12588C21.0003 10.3121 19.2342 12.0844 17.0557 12.0844C14.8771 12.0844 13.111 10.3121 13.111 8.12588C13.111 5.93969 14.8771 4.16735 17.0557 4.16735C19.2342 4.16735 21.0003 5.93969 21.0003 8.12588ZM10.8894 4.95852C10.8894 7.14472 9.12328 8.91705 6.94473 8.91705C4.76618 8.91705 3.00005 7.14472 3.00005 4.95852C3.00005 2.77233 4.76618 1 6.94473 1C9.12328 1 10.8894 2.77233 10.8894 4.95852Z",
    stroke: "#001E64",
    strokeWidth: 1.57303,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesIcon);
export default __webpack_public_path__ + "static/media/peoplesIcon.aeaa5a1dbb689b8e2fd9394c12ea2a68.svg";
export { ForwardRef as ReactComponent };